const useColumnsTwo = (setProduct, handleAdd, handleDelete) => {
  const columnsInside = [
    { Header: "รหัสสินค้า", accessor: "product_code" },
    { Header: "ชื่อสินค้า", accessor: "product_name" },
    // { Header: "ราคา", accessor: "product_price" },
    // { Header: "จำนวน", accessor: "total_amount" },
    // { Header: "ราคารวม", accessor: "total_price" },
  ];

  return columnsInside;
};
// color={"#000000"}
// opacity={0.4}
export default useColumnsTwo;
